import { useMemo, useState } from 'react';
import _isEmpty from 'lodash/isEmpty';
import _map from 'lodash/map';
import _filter from 'lodash/filter';
import _reduce from 'lodash/reduce';
import {
  EXPERIENCE_TAGS as PROMO_EXPERIENCE_TAGS
} from '@thd-olt-component-react/promotion-products/dist/utils/constants';
import { useProductDataStore } from '../../../store';

const priceReducer = (bundleSkus, productData, key) => _reduce(bundleSkus, (prev, curr) => {
  let total = prev || 0;
  total += productData?.[curr]?.pricing?.[key] || 0;
  return total;
}, 0);

const promotionReducer = (bundleSkus, productData, key) => _reduce(bundleSkus, (prev, curr) => {
  let total = prev || 0;
  total += productData?.[curr]?.pricing?.promotion?.[key] || 0;
  return total;
}, 0);

const promotionTypeReducer = (bundleSkus, productData) => _reduce(bundleSkus, (prev, curr) => {
  let promoType = prev || null;
  if (promoType === PROMO_EXPERIENCE_TAGS.BMSM) {
    return promoType;
  }
  promoType = productData?.[curr]?.pricing?.conditionalPromotions?.[0]?.promotionTags?.[0];
  return promoType;
});

const transformResponse = (
  productData, bundleSkus = null
) => {
  const anchorSku = bundleSkus?.[0];
  const originalPrice = priceReducer(bundleSkus, productData, 'original');
  const valuePrice = priceReducer(bundleSkus, productData, 'value');
  const dollarOffPrice = promotionReducer(bundleSkus, productData, 'dollarOff');

  return {
    graphProduct: {
      ...productData?.[anchorSku],
      pricing: {
        ...productData?.[anchorSku]?.pricing,
        original: originalPrice
          ? valuePrice + dollarOffPrice
          : null,
        value: valuePrice,
        promotion: {
          ...productData?.pricing?.promotion,
          dollarOff: dollarOffPrice || null,
          percentageOff: originalPrice
            ? Math.round((dollarOffPrice / (valuePrice + dollarOffPrice)) * 100)
            : null
        }
      }
    },
    promoType: promotionTypeReducer(bundleSkus, productData),
    anchorSku: String(anchorSku),
  };
};

export default (bundleSkusData) => {
  const [response, setResponse] = useState(null);
  const productData = useProductDataStore((state) => state.productData);

  useMemo(() => {

    const asyncResolver = async (bundleSkus) => {
      const transformed = transformResponse(productData, bundleSkus) || null;
      return setResponse(transformed);
    };

    asyncResolver(bundleSkusData);

  }, [productData]);

  return [response];
};
